<template>
    <div v-if="!paymentSuccess" class="payment-form">
        <h1>{{ $t('template.payment.advanced') }}</h1>
        <p>{{ $t('template.payment.price') }}</p>
        <p>
            <b>{{ $t('template.payment.firstMonth') }}</b>
        </p>

        <form class="form" @submit.prevent="onSubmit">
            <FormItem v-bind="form.items.cardNumber.props">
                <component
                    :is="form.items.cardNumber.component"
                    name="cardNumber"
                    @input="formatCardNumber"
                    v-model="form.items.cardNumber.value"
                    v-bind="form.items.cardNumber.props"
                    @update-field="onUpdateFieldValue"
                />
            </FormItem>

            <div class="form__col">
                <FormItem v-bind="form.items.expires.props" class="col-1-3">
                    <component
                        :is="form.items.expires.component"
                        name="expires"
                        @input="formatExpires"
                        v-model="form.items.expires.value"
                        v-bind="form.items.expires.props"
                        @update-field="onUpdateFieldValue"
                    />
                </FormItem>
                <FormItem v-bind="form.items.cvv.props" class="col-1-3">
                    <component
                        :is="form.items.cvv.component"
                        name="cvv"
                        @input="formatCVV"
                        v-model="form.items.cvv.value"
                        v-bind="form.items.cvv.props"
                        @update-field="onUpdateFieldValue"
                    />
                </FormItem>
            </div>

            <FormItem v-bind="form.items.cardName.props">
                <component
                    :is="form.items.cardName.component"
                    name="cardName"
                    @input="formatCardName"
                    v-model="form.items.cardName.value"
                    v-bind="form.items.cardName.props"
                    @update-field="onUpdateFieldValue"
                />
            </FormItem>

            <FormItem v-bind="form.items.countryOrRegion.props">
                <SelectCustom
                    v-model="form.items.countryOrRegion.value"
                    v-bind="form.items.countryOrRegion.props"
                    name="countryOrRegion"
                    :variants="form.items.countryOrRegion.props.variants"
                    :selected="form.items.countryOrRegion.props.selected"
                    :placeholder="placeholderFormated(form.items.countryOrRegion.props)"
                    @update-field="onUpdateFieldValue"
                >
                </SelectCustom>
            </FormItem>

            <FormError v-if="form.errors.length" :errors="form.errors" />

            <div class="form-button">
                <Button>{{ $t('template.payment.buttons.pay') }}</Button>
            </div>
        </form>
    </div>

    <PaymentSuccess v-else></PaymentSuccess>
</template>

<script>
import Form from '@/entities/form';
import validateField from '@/entities/validator';
import FormItem from '@/components/form/item.vue';
import FormError from '@/components/form/error.vue';
import InputText from '@/components/form/controls/inputText.vue';
import InputPassword from '@/components/form/controls/inputPassword.vue';
import Button from '@/components/common/button.vue';
import PaymentSuccess from '@/components/auth/paymentSuccess.vue';
import SelectCustom from '@/components/form/controls/selectCustom.vue';
import AuthService from '@/services/AuthService.ts';

export default {
    name: 'PaymentForm',
    components: {
        FormItem,
        FormError,
        InputText,
        InputPassword,
        Button,
        PaymentSuccess,
        SelectCustom,
    },
    data() {
        return {
            id: 'test',
            paymentSuccess: false,
            form: new Form({
                action: this.formAction,
                validateHandler: this.validateHandler,
                successHandler: this.successHandler,
                failedHandler: this.failedHandler,
                items: {
                    cardNumber: {
                        value: '',
                        type: 'field',
                        component: 'input-text',
                        props: {
                            rules: ['noEmpty'],
                            label: this.$t('template.payment.fields.cardNumber'),
                        },
                    },
                    expires: {
                        value: '',
                        type: 'field',
                        component: 'input-text',
                        props: {
                            rules: ['noEmpty'],
                            label: this.$t('template.payment.fields.expires'),
                            placeholder: 'MM / YY',
                        },
                    },
                    cvv: {
                        value: '',
                        type: 'field',
                        component: 'input-password',
                        props: {
                            type: 'number',
                            rules: ['noEmpty'],
                            label: this.$t('template.payment.fields.cvv'),
                        },
                    },
                    cardName: {
                        value: '',
                        type: 'field',
                        component: 'input-text',
                        props: {
                            rules: ['noEmpty'],
                            label: this.$t('template.payment.fields.cardName'),
                        },
                    },
                    countryOrRegion: {
                        value: '',
                        type: 'field',
                        props: {
                            rules: ['noEmpty'],
                            label: this.$t('template.payment.fields.countryOrRegion'),
                            variants: [
                                { title: this.$t('template.payment.countries.AF'), value: 'AF' },
                                { title: this.$t('template.payment.countries.AZ'), value: 'AZ' },
                                { title: this.$t('template.payment.countries.CK'), value: 'CK' },
                            ],
                            selected: 'countryOrRegion',
                        },
                    },
                },
            }),
        };
    },
    methods: {
        formAction(formData) {
            return AuthService.addPayment(this.id, formData);
        },
        validateHandler(isValid) {
            console.log('validateHandler', isValid);
        },
        successHandler(result) {
            console.log('successHandler', result);
            this.paymentSuccess = true;
            setTimeout(() => this.$router.push({ name: 'Building' }), 5000);
        },
        failedHandler(result) {
            console.log('failedHandler', result);
        },
        onSubmit() {
            this.form.submit();
        },
        onUpdateFieldValue(payload) {
            console.log(payload);
            const { name } = payload;
            const item = this.form.items[name];
            item.props.errors = validateField(item.value, item.props.rules);
        },
        placeholderFormated: function (itemProps) {
            const placeholder = (() => {
                if (itemProps.placeholder) return this.$t(itemProps.placeholder);
                if (itemProps.label) return this.$t(itemProps.label);
                return itemProps.name;
            })();
            const isNoEmpty = itemProps.rules ? itemProps.rules.includes('noEmpty') : false;
            return isNoEmpty ? `${placeholder}*` : placeholder;
        },
        formatCardNumber(e) {
            const val = e.target.value;
            const v = val.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
            const matches = v.match(/\d{4,16}/g);
            const match = (matches && matches[0]) || '';
            const parts = [];
            for (let i = 0, len = match.length; i < len; i += 4) {
                parts.push(match.substring(i, i + 4));
            }
            if (parts.length) {
                this.form.items.cardNumber.value = parts.join(' ');
            } else {
                this.form.items.cardNumber.value = v;
            }
        },
        formatExpires(e) {
            const val = e.target.value;
            let v = val.replace(/\D/g, '').slice(0, 4);
            if (v.length >= 3) {
                this.form.items.expires.value = `${v.slice(0, 2)}/${v.slice(2)}`;
            } else {
                this.form.items.expires.value = v;
            }
        },
        formatCVV(e) {
            const val = e.target.value;
            if (val.length >= 2) {
                this.form.items.cvv.value = `${val.slice(0, 3)}`;
            }
        },
        formatCardName(e) {
            const val = e.target.value;
            this.form.items.cardName.value = val.toUpperCase();
        },
    },
};
</script>

<style lang="scss">
.payment-form {
    display: block;
    width: 100%;
    h1 {
        margin-top: 0;
        font-size: 32px;
        margin-bottom: 24px;
    }
}
</style>
